module.exports = __webpack_public_path__ + "static/media/tachometer-alt-slow.78556714.svg";